import { Helmet } from "react-helmet-async";
import { localeFontStylesheet } from "./localeFontStylesheet";

/** Fonts follow the owning surface, including public SSR; no browser negotiation here. */
export function LocaleFontStyles({ locale }: { locale: string }) {
  const href = localeFontStylesheet(locale);
  return href ? <Helmet defer={false}><link rel="stylesheet" href={href} data-localization-fonts={locale} /></Helmet> : null;
}
